import { render, staticRenderFns } from "./files-change-request.vue?vue&type=template&id=45f1c4ac"
import script from "./files-change-request.ts?vue&type=script&lang=ts&external"
export * from "./files-change-request.ts?vue&type=script&lang=ts&external"
import style0 from "./files-change-request.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f1c4ac')) {
      api.createRecord('45f1c4ac', component.options)
    } else {
      api.reload('45f1c4ac', component.options)
    }
    module.hot.accept("./files-change-request.vue?vue&type=template&id=45f1c4ac", function () {
      api.rerender('45f1c4ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/create-in-year-budget-request/create-iybr-form/files-change-request/files-change-request.vue"
export default component.exports